/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ChildIndividualQuestionModeWithList = {
  readonly id?: number;
  name: string;
  question_type?: ChildIndividualQuestionModeWithList.question_type;
  options?: Array<number>;
  description?: string | null;
  questionnaire?: number;
  new_options?: Array<string>;
};
export namespace ChildIndividualQuestionModeWithList {
  export enum question_type {
    TEXT = 'text',
    DATE = 'date',
    DROPDOWN = 'dropdown',
    MULTIPLE = 'multiple',
  }
}
